import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { Button, ButtonGroup } from "aible";

import * as viewReducer from "containers/View/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import ChatBlueprintItem from "containers/View/Item/ChatBlueprintItem";
import BlueprintCreate from "components/ChatGPT/BlueprintCreate";

import SubView from "components/View/SubView";
import NextSubView from "components/Next/View/SubView";
import ViewMessage from "components/View/ViewMessage";

import BlueprintTile from "components/Tiles/BlueprintTile.js";
import EmptyTile from "components/Tiles/EmptyTile";
import BlueprintViewContainer from "containers/View/Blueprint";
import ChatToneView from "components/ChatTone/ChatToneView";

import { getIsEDG } from "containers/Gallery/GalleryReducer";
import { isEnabled } from "utils/featureFlags";

class ChatBlueprintViewContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { renderView: "USE_CASES" };
  }

  handleClick(data) {
    const { openBlueprint } = this.props;
    return openBlueprint(data.id);
  }

  renderFirstTile() {
    const {
      hideCreateNew,
      createBlueprint,
      openBlueprint,
      updateIsEditBlueprint,
      openTemplateBlueprint,
      isSaveDataset,
      history,
      type,
      handleCreate,
      hideFirstTile,
      showQuickStart,
      onClick,
      folderEditPermission,
      isMini,
      firstTile
    } = this.props;

    if (hideFirstTile || !isEnabled("chat-aible-advanced-controls")) {
      return <EmptyTile />;
    }

    return (
      <React.Fragment>
        <BlueprintCreate isCreateDisabled={!folderEditPermission} />
      </React.Fragment>
    );
  }

  renderFirstRow() {
    const { openBlueprint, folderEditPermission } = this.props;

    return folderEditPermission ? (
      <Button type="secondary" onClick={() => openBlueprint("new")}>
        {"Create New Blueprint"}
      </Button>
    ) : (
      <React.Fragment></React.Fragment>
    );
  }

  getHeaders() {
    return ["Name", "Creation"];
  }

  getIsCategorical(blueprint) {
    return blueprint &&
      blueprint.wizard &&
      blueprint.wizard.dataset &&
      blueprint.wizard.dataset.outcome &&
      blueprint.wizard.dataset.fields &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome] &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type
      ? blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type === "categorical"
      : true;
  }

  getIsNumerical(blueprint) {
    return blueprint &&
      blueprint.wizard &&
      blueprint.wizard.dataset &&
      blueprint.wizard.dataset.outcome &&
      blueprint.wizard.dataset.fields &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome] &&
      blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type
      ? blueprint.wizard.dataset.fields[blueprint.wizard.dataset.outcome].type === "number"
      : true;
  }

  render() {
    const {
      onClick,
      onEditClick,
      isTile,
      isMini,
      hideCreateNew,
      resetDataset,
      data,
      isCategorical,
      isNumerical,
      isNext,
      updateMoveBlueprintId,
      searchText
    } = this.props;

    const categoricalData = isCategorical
      ? data.filter((d) => this.getIsCategorical(d))
      : isNumerical
        ? data.filter((d) => this.getIsNumerical(d))
        : data;

    const retData = categoricalData.filter((d) => d.name.toLowerCase().includes(searchText.toLowerCase()));

    return isNext ? (
      <NextSubView
        {...this.props}
        data={retData}
        height={isMini ? 265 : undefined}
        label="Blueprints"
        headers={this.getHeaders()}
        firstTile={this.renderFirstTile()}
        firstRow={hideCreateNew ? <div /> : this.renderFirstRow()}
        emptyMessage={
          getIsEDG() ? (
            <ViewMessage title={"Add Blueprints to Organize Your Data"}>
              {"Blueprints apply the appropriate descriptions to your dataset, ensure sensitive fields are protected, " +
                "prep your data for AI modeling, and help build out your organizations data dictionary."}
            </ViewMessage>
          ) : undefined
        }
        length={retData.length}
        isInfinite={true}
        renderTile={(columnIndex, style) =>
          retData && retData.length > columnIndex ? (
            <ChatBlueprintItem
              id={retData[columnIndex].id}
              key={columnIndex}
              style={style}
              resetDataset={resetDataset}
              isTile={isTile}
              onClick={onClick}
              onEditClick={onEditClick}
              isNext={isNext}
              hideDelete={isNext}
              isMini={isMini}
              updateMoveBlueprintId={updateMoveBlueprintId}
            />
          ) : undefined
        }
        childrenLength={retData.length}
        isTile={isTile}
        hideShowMore
      />
    ) : (
      <div>
        <React.Fragment>
          <div
            style={{
              marginTop: "12px",
              justifyContent: "center",
              display: "flex"
            }}
          >
            <ButtonGroup>
              <Button
                type="secondary"
                active={this.state.renderView === "USE_CASES"}
                onClick={() => this.setState({ renderView: "USE_CASES" })}
                style={{
                  width: "134px"
                }}
              >
                {"Agent Templates"}
              </Button>
              <Button
                type="secondary"
                active={this.state.renderView === "CHAT_TONES"}
                onClick={() => this.setState({ renderView: "CHAT_TONES" })}
                style={{
                  width: "134px"
                }}
              >
                {"Chat Tones"}
              </Button>
              <Button
                type="secondary"
                active={this.state.renderView === "BLUEPRINTS"}
                onClick={() => this.setState({ renderView: "BLUEPRINTS" })}
                style={{
                  width: "134px"
                }}
              >
                {"Blueprints"}
              </Button>
            </ButtonGroup>
          </div>
          {this.state.renderView === "USE_CASES" && (
            <SubView
              {...this.props}
              data={retData}
              height={isMini ? 265 : undefined}
              label="Blueprints"
              headers={this.getHeaders()}
              firstTile={this.renderFirstTile()}
              firstRow={hideCreateNew ? <div /> : this.renderFirstRow()}
              emptyMessage={
                getIsEDG() ? (
                  <ViewMessage title={"Add Blueprints to Organize Your Data"}>
                    {"Blueprints apply the appropriate descriptions to your dataset, ensure sensitive fields are protected, " +
                      "prep your data for AI modeling, and help build out your organizations data dictionary."}
                  </ViewMessage>
                ) : undefined
              }
              length={retData.length}
              isInfinite={true}
              renderTile={(columnIndex, style) =>
                retData && retData.length > columnIndex ? (
                  <ChatBlueprintItem
                    id={retData[columnIndex].id}
                    key={columnIndex}
                    style={style}
                    resetDataset={resetDataset}
                    isTile={isTile}
                    onClick={onClick}
                    onEditClick={onEditClick}
                    isNext={isNext}
                    isMini={isMini}
                  />
                ) : undefined
              }
              childrenLength={retData.length}
              isTile={isTile}
              hideShowMore
            />
          )}
          {this.state.renderView === "BLUEPRINTS" && <BlueprintViewContainer resetDataset />}
          {this.state.renderView === "CHAT_TONES" && <ChatToneView />}
        </React.Fragment>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchNext: () => dispatch(blueprintReducer.fetchNextBlueprints()),
  openBlueprint: (id) => dispatch(blueprintReducer.openBlueprint(id)),
  updateIsEditBlueprint: (value) => dispatch(unifiedProjectReducer.updateIsEditBlueprint("new", value)),

  openTemplateBlueprint: (aibleMode, isSaveDataset, type) =>
    dispatch(blueprintReducer.openTemplateBlueprint(aibleMode, isSaveDataset, type)),

  createBlueprint: (blueprint) => dispatch(blueprintReducer.createBlueprintFromBlueprint(blueprint)),

  updateMoveBlueprintId: (blueprintId) => dispatch(foldersReducer.updateMoveBlueprintId(blueprintId))
});

const mapStateToProps = (state, ownProps) => {
  const selectedFolder = foldersReducer.getSelectedFolder(state);
  const isLoading = selectedFolder !== undefined && globalReducer.getIsBlueprintsLoading(state);
  let data = viewReducer.getChatBlueprints(state);
  if (data?.length > 0 && ownProps.searchTerm?.length > 0) {
    data = data.filter((d) => d.name && d.name.toLowerCase().indexOf(ownProps.searchTerm.toLowerCase()) !== -1);
  }

  return {
    isTile: ownProps.isTile ? ownProps.isTile : viewReducer.getIsTile(state),
    type: viewReducer.getType(state),

    data: data,
    searchText: viewReducer.getSearch(state),
    isLoading: isLoading,
    folderEditPermission: foldersReducer.getUserEditPermission(state, selectedFolder)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ChatBlueprintViewContainer);
